import { Link } from "react-router-dom";

const contact = {
    whatsapp: "https://wa.me/5585985655143",
    instagram: "https://instagram.com/m1lkcode",
};

const sectionTitleClass = "font-display text-xl md:text-2xl text-brand-light";
const sectionTextClass = "font-body text-sm md:text-base text-brand-light/80 leading-relaxed";

const LegalLayout = ({ title, children }) => {
    const updatedAt = new Date().toLocaleDateString("pt-BR");

    return (
        <div className="min-h-screen bg-brand-dark relative">
            <div className="noise-overlay" />

            <main className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16">
                <div className="flex items-center justify-between gap-4 mb-10">
                    <Link to="/" className="btn-outline text-xs md:text-sm">
                        Voltar para Início
                    </Link>
                    <p className="font-body text-xs md:text-sm text-brand-grey">
                        Atualizado em {updatedAt}
                    </p>
                </div>

                <h1 className="font-display text-3xl md:text-5xl text-brand-light mb-8">{title}</h1>

                <div className="space-y-8">{children}</div>
            </main>
        </div>
    );
};

export const TermsOfUsePage = () => {
    return (
        <LegalLayout title="Política de Uso">
            <section className="space-y-3">
                <h2 className={sectionTitleClass}>1. Aceitação</h2>
                <p className={sectionTextClass}>
                    Ao acessar este site, você concorda com estes termos de uso. Caso não concorde com qualquer
                    condição, recomendamos não utilizar os serviços e conteúdos apresentados.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>2. Uso permitido</h2>
                <p className={sectionTextClass}>
                    É permitido navegar, solicitar orçamentos e entrar em contato para contratação de serviços.
                    Não é permitido utilizar este site para práticas ilegais, tentativa de invasão, coleta de dados
                    sem autorização ou qualquer ação que comprometa a segurança da plataforma.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>3. Propriedade intelectual</h2>
                <p className={sectionTextClass}>
                    Conteúdos, textos, identidade visual e materiais publicados pertencem à M1LK CODE e não podem
                    ser reproduzidos sem autorização prévia.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>4. Limitação de responsabilidade</h2>
                <p className={sectionTextClass}>
                    Buscamos manter as informações sempre corretas e atualizadas, porém não garantimos ausência de
                    erros, indisponibilidades temporárias ou alterações de conteúdo sem aviso prévio.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>5. Contato</h2>
                <p className={sectionTextClass}>
                    Para dúvidas sobre estes termos, entre em contato pelo WhatsApp ou Instagram oficial:
                </p>
                <div className="flex flex-wrap gap-3">
                    <a href={contact.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-outline text-xs">
                        WhatsApp
                    </a>
                    <a href={contact.instagram} target="_blank" rel="noopener noreferrer" className="btn-outline text-xs">
                        Instagram
                    </a>
                </div>
            </section>
        </LegalLayout>
    );
};

export const PrivacyPolicyPage = () => {
    return (
        <LegalLayout title="Política de Privacidade">
            <section className="space-y-3">
                <h2 className={sectionTitleClass}>1. Dados coletados</h2>
                <p className={sectionTextClass}>
                    Podemos coletar dados fornecidos voluntariamente por você em formulários e contatos, como nome,
                    telefone, e-mail e informações necessárias para atendimento e proposta comercial.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>2. Finalidade do uso</h2>
                <p className={sectionTextClass}>
                    Os dados são usados para responder solicitações, prestar atendimento, elaborar propostas,
                    executar serviços contratados e melhorar a experiência de navegação.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>3. Compartilhamento</h2>
                <p className={sectionTextClass}>
                    Não vendemos seus dados. O compartilhamento pode ocorrer apenas quando necessário para execução
                    do serviço, cumprimento de obrigações legais ou mediante consentimento do titular.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>4. Armazenamento e segurança</h2>
                <p className={sectionTextClass}>
                    Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acesso não
                    autorizado, alteração, divulgação ou destruição indevida.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>5. Direitos do titular</h2>
                <p className={sectionTextClass}>
                    Você pode solicitar acesso, correção, atualização ou exclusão de dados pessoais a qualquer
                    momento pelos canais oficiais de contato.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>6. Integrações e assistentes de atendimento</h2>
                <p className={sectionTextClass}>
                    Alguns serviços da M1LK CODE incluem assistentes de atendimento automatizado e integrações com
                    plataformas de terceiros, como WhatsApp, Google Agenda, Google Planilhas e provedores de
                    inteligência artificial. Nesses casos, podemos tratar o nome, o telefone e o conteúdo das
                    mensagens enviadas pelo usuário, com a única finalidade de responder, agendar, remarcar ou
                    encaminhar o atendimento ao responsável pelo estabelecimento contratante.
                </p>
                <p className={sectionTextClass}>
                    Cada cliente contratante é o controlador dos dados dos seus próprios usuários finais, e a
                    M1LK CODE atua como operadora, tratando esses dados apenas conforme as instruções do contrato
                    firmado.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>7. Dados obtidos por APIs do Google</h2>
                <p className={sectionTextClass}>
                    Quando um cliente autoriza o acesso à sua conta Google, acessamos apenas os dados necessários
                    para a execução do serviço contratado, como a leitura de horários disponíveis e a criação,
                    alteração ou cancelamento de eventos na agenda autorizada. Não acessamos e-mails, contatos,
                    arquivos ou qualquer outro dado fora do escopo autorizado.
                </p>
                <p className={sectionTextClass}>
                    Esses dados não são vendidos, não são usados para publicidade, não são usados para treinar
                    modelos de inteligência artificial e não são compartilhados com terceiros, salvo quando
                    estritamente necessário para operar o serviço ou por obrigação legal. A autorização pode ser
                    revogada a qualquer momento pelo próprio cliente, nas configurações de segurança da conta
                    Google, e o acesso é encerrado imediatamente.
                </p>
                <p className={sectionTextClass}>
                    O uso e a transferência, pela M1LK CODE, de informações recebidas das APIs do Google seguem a
                    Política de Dados do Usuário dos Serviços de API do Google, incluindo os requisitos de Uso
                    Limitado.
                </p>
            </section>
        </LegalLayout>
    );
};

export const DataDeletionPage = () => {
    return (
        <LegalLayout title="Política de Exclusão de Dados">
            <section className="space-y-3">
                <h2 className={sectionTitleClass}>1. Solicitação de exclusão</h2>
                <p className={sectionTextClass}>
                    Você pode solicitar a exclusão dos seus dados pessoais tratados pela M1LK CODE a qualquer
                    momento, enviando mensagem pelos canais oficiais.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>2. Como solicitar</h2>
                <p className={sectionTextClass}>
                    Informe os dados que deseja remover e um meio de contato para confirmação da sua identidade.
                    Essa verificação é necessária para proteger sua privacidade e evitar solicitações indevidas.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>3. Prazo de atendimento</h2>
                <p className={sectionTextClass}>
                    Após validação da solicitação, iniciaremos o processo de exclusão em prazo razoável, respeitando
                    obrigações legais e regulatórias que possam exigir retenção parcial de informações.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className={sectionTitleClass}>4. Canais oficiais</h2>
                <div className="flex flex-wrap gap-3">
                    <a href={contact.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-outline text-xs">
                        Solicitar via WhatsApp
                    </a>
                    <a href={contact.instagram} target="_blank" rel="noopener noreferrer" className="btn-outline text-xs">
                        Solicitar via Instagram
                    </a>
                </div>
            </section>
        </LegalLayout>
    );
};
